<template>
    <el-dialog :title="$t('users.dialog_title')" :visible.sync="showPopup" append-to-body  class="my-dialog-class">
        
        <el-form :label-position="'top'" :inline="false"  
            :rules="rules"
            label-width="100%"  :model='selectedObject'  ref='my-form' @submit.prevent="save" v-loading="loading">
             <el-row :gutter="12">
                 <el-col :span="12">
                    <el-form-item :label="$t('users.name')" prop="Name" :required="true">
                        <el-input  v-model="selectedObject.Name" placeholder="Name" autofocus></el-input>
                    </el-form-item>
                 </el-col>
                 <el-col :span="12">
                    <el-form-item :label="$t('users.email')" prop="Email" :required="true">
                        <el-input v-model="selectedObject.Email" placeholder="Email"></el-input>
                    </el-form-item>
                 </el-col>

                 <el-col :span="24" v-if="mode=='add'">
                    <el-form-item :label="$t('users.password')" prop="Password" :required="true">
                        <el-input v-model="selectedObject.Password" placeholder="Password"></el-input>
                    </el-form-item>
                 </el-col>

                <el-col :span="12">
                    <el-form-item :label="$t('users.user_group')" prop="IdUserGroup" :required="true">
                        <el-select v-model="selectedObject.IdUserGroup" placeholder="User group" class="full-width">
                            <el-option v-for="item in groups" :key="item.Id" :label="item.Name" :value="item.Id"></el-option>
                        </el-select>
                    </el-form-item>
                 </el-col>

                <el-col :span="12">
                    <el-form-item :label="$t('users.user_factory')" prop="IdFactory" :required="true">
                        <el-select v-model="selectedObject.IdFactory" placeholder="User factory" class="full-width">
                            <el-option v-for="item in factories" :key="item.Id" :label="item.ShortCode" :value="item.Id"></el-option>
                        </el-select>
                    </el-form-item>
                 </el-col>
             </el-row>
        </el-form>

        <span slot="footer" class="dialog-footer">
            <el-button @click="showPopup=false">{{ $t("cancel") }}</el-button>
            <el-button type="primary" @click="save">{{ $t("confirm") }}</el-button>
        </span>
    </el-dialog>
</template>

<script>
import settings from "./../../backend/LocalSettings";

export default {
  name: "user-dialog",
  data () {
    return { 
      loading: false,
      showPopup: false,
      mode: 'add',
      selectedObject: { Name:"", Password: "", Email: "", IdUserGroup : "-1", IdFactory : "-1" },
      groups: [],
      factories: [],
      rules: {
          Name: [ { required: true } ],
          Email: [ {required: true } ],
          IdUserGroup: [ {required: true } ],
          IdFactory: [ {required: true } ]
      }
    }
  },
  methods: {
     show_me: function( selectedObject ) {
        this.mode = "edit";
        if( selectedObject == null ) {
            this.mode = "add";
            this.selectedObject.Name        = "";
            this.selectedObject.Password    = "";
            this.selectedObject.Email       = "";
        } else {
            this.selectedObject  = JSON.parse( JSON.stringify( selectedObject ) );
        }
        this.showPopup       = true;
    },
    load_info: function(){
        this.loading = true;
        this.$http
          .post('users/get_dialog_info',  {} )
          .then(function (response) {
            this.loading = false;
            if( settings.verify_response(response, this.$rights)) {
              this.groups    = response.body.Groups;
              this.factories = response.body.Factories;
              this.selectedObject.IdUserGroup = this.groups[0].Id;
              this.selectedObject.IdFactory   = this.factories[0].Id;
            } else {
              this.$router.push("/");
            }
          });
    },
    save: function() {
        this.$refs['my-form'].validate((valid) => {
          if (valid) {
            this.loading = true;
            this.$http
            .post('users/save',  { mode: this.mode, object: this.selectedObject } )
            .then(function (response) {
                this.loading = false;
                if( settings.verify_response(response, this.$rights)) {
                    if(response.body.ErrorMessage != "" )
                    {
                        this.$message.error( response.body.ErrorMessage );
                    } else {
                        this.showPopup = false;
                        this.$emit("save");
                    }
                    
                } else {
                    this.$router.push("/");
                }
            });
          }
        });
    }
  },
  mounted: function() {
      this.load_info();
  }
};
</script>

<style lang="less" scoped>
    .full-width {
        width: 100%;
    }
</style>